<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useLifeListStore, type LifeDTO, loadLifeListData } from '@/composables/life/life'
import { useRouter } from 'vue-router'
import { titleBar } from '@/composables/menu/title'

const { t } = useI18n()

const { expandSize } = defineProps({
  expandSize: {
    type: Number,
    default: 3
  }
})

const lifeListStore = useLifeListStore()
const router = useRouter()

// function contextMenuGroup(item: LifeDTO): Array<Array<ContextMenuItem>> {
//   const firstGroup: Array<ContextMenuItem> = new Array<ContextMenuItem>()
//   if (item.memorialServices && item.memorialServices.length > 0) {
//     firstGroup.push({ name: t('menu.memo'), key: 'memo', icon: 'i-tabler:message-heart' } as ContextMenuItem)
//   }
//   // if (item.sayTos && item.sayTos.length > 0) {
//   //   firstGroup.push({ name: t('menu.sayto'), key: 'sayto', icon: 'i-mingcute:ear-line' } as ContextMenuItem)
//   // }
//   return [firstGroup, [{ name: t('menu.profile'), key: 'profile', icon: 'i-iconamoon:profile' } as ContextMenuItem]]
// }

const emit = defineEmits(['onItemSelect'])

// function onItemClicked(item: ContextMenuItem, obj: any) {
//   const life = obj as LifeDTO
//   // console.log('item clicked: ', item, life.memorialServices[0].id)
//   emit('onItemSelect', item.key)
//   switch (item.key) {
//     case 'memo':
//       router.push('/m/' + life.memorialServices[0].id)
//       break
//     // case 'sayto':
//     //   router.push('/sayto/' + life.sayTos[0].id)
//     //   break
//     case 'profile':
//       router.push('/life/' + life.id)
//       break
//     default:
//   }
// }

const isExpand = ref(false)

const filteredItems = computed(() => {
  const filtered = lifeListStore.lifeList.filter((life) => !life.archived)
  // console.log("filtered items: ", filtered.length);
  return filtered
})

const expandableItems = computed(() => {
  return filteredItems.value.slice(
    0,
    filteredItems.value.length > expandSize
      ? isExpand.value
        ? filteredItems.value.length
        : expandSize
      : filteredItems.value.length
  )
})

function onClickItem(item: LifeDTO) {
  if (item.memorialServices && item.memorialServices.length > 0) {
    router.push('/m/' + item.memorialServices[0].id)
  } else {
    router.push('/life/' + item.id)
  }
  emit('onItemSelect', item)
}

function onLifeDetailsClick(item: LifeDTO) {
  router.push('/life/' + item.id)
  emit('onItemSelect', item)
}

function refreshLifeList() {
  loadLifeListData()
}
</script>
<template>
  <div w-full flex="~ col">
    <div v-if="lifeListStore.state === 'failed'" flex="~ row" min-h-30 w-full items-center>
      <button py-1.5 text-sm btn-outline-plain @click="refreshLifeList">{{ $t('action.click_to_refresh') }}</button>
    </div>
    <div h-auto w-full flex="~ col" v-if="lifeListStore.state !== 'failed'">
      <SubNavItem
        v-for="(item, index) in expandableItems"
        :key="index"
        :name="item.name.fullName"
        my-1px
        :icon="item.serviceShare ? 'i-bi:people' : ''"
        :selected="titleBar.category === 'lifepage' && item.id === titleBar?.lifeId"
        @onSelect="onClickItem(item)">
        <template #action>
          <!-- <ContextMenuView :menuGroups="contextMenuGroup(item)" :obj="item" @onItemClicked="onItemClicked">
            <template #trigger>
              <RIcon v-if="!item.serviceShare" icon="i-iconamoon:menu-kebab-horizontal" :size="'small'"></RIcon>
            </template>
          </ContextMenuView> -->
          <el-tooltip
            v-if="!item.serviceShare"
            :content="$t('menu.life_details')"
            placement="top"
            effect="dark"
            :show-after="500">
            <RIcon icon="i-ph:user-list" :size="'medium'" :grey="true" @click="onLifeDetailsClick(item)"></RIcon>
          </el-tooltip>
          <!-- <button v-if="!item.serviceShare" py-1 px-2 rounded min-w-12 bg-transparent hover:underline underline-offset-3  text-sm text-third>{{ $t('menu.details') }}</button> -->
        </template>
      </SubNavItem>
      <p
        v-if="filteredItems && filteredItems.length > expandSize"
        ml-4
        cursor-pointer
        my-2
        py-1
        text-third
        hover:underline
        @click="isExpand = !isExpand">
        {{ isExpand ? $t('menu.less') : $t('menu.more') }}
      </p>
    </div>
  </div>
</template>
<style lang="" scoped></style>
